import React from 'react';

export const TrackStepper = ({ Progress, type }) => {
    let steps = {
        stepsArr: [
            {
                title: "Sale",
                imageURL: "./images/Sale.svg",
                status: false,
                isActive: false
            },
            {
                title: "Confirm",
                imageURL: "./images/Confirm.svg",
                status: false,
                isActive: false
            },
            {
                title: "Payment",
                imageURL: "./images/payment.svg",
                status: false,
                isActive: false
            },
            {
                title: "Final",
                imageURL: "./images/FinalSave.svg",
                status: false,
                isActive: false
            }
        ],
        lineWidth: Progress
    };

    steps.stepsArr.forEach((step, index) => {
        const stepWidths = ['20%', '50%', '80%', '100%'];
        if (stepWidths.indexOf(Progress) >= index) {
            step.status = true;
            step.isActive = true;
        } else {
            step.status = false;
            step.isActive = false;
        }
    });
    /*.filter(d => (formData.payment === 'PAYLATER' && d.title !== 'Payment') || (formData.payment !== 'PAYLATER' && d.title))*/
    let isCancelled = steps?.stepsArr?.filter(item => item.title === 'Cancelled').length > 0 ? true : false;
    return (
        <>
            <div className="tracking-container overflow-hidden">
                <div className="tracking-steps position-relative">
                    {steps?.stepsArr?.filter(d => (type === 'Customer' && d.title !== 'Sale') || (type !== 'Customer' && d.title)).map((item, index) => {
                        return <div className='step' index={index}>
                            <span className={`step-icon ${item.isActive ? 'pulse' : ''}`} style={{ borderColor: item.isActive ? (item.title !== "Cancelled" ? '#a587ff' : 'red') : item.status ? 'green' : '' }}>
                                <img className={`${item.isActive ? 'animateupdown' : ''}`} src={item.imageURL} style={{ filter: item.status ? 'inherit' : '', opacity: item.status ? '1' : '' }} alt="" />
                            </span>
                            <span className="step-title">{item.title}</span>
                        </div>
                    })}
                    <div className="tracking-line position-absolute" style={{ width: steps?.lineWidth, background: isCancelled ? 'linear-gradient(to bottom, #c30d0d, #ff7b7b, #ff0000)' : '' }}>
                    </div>
                    <div className="tracking-lineover"></div>
                </div>
            </div>
        </>
    );
}

